import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../objects/Globals';
import { DetailService } from '../services/detail.service';
import { TokenManager } from '../Globals';
var LayoutDetailComponent = /** @class */ (function () {
    function LayoutDetailComponent(route, globals, router, detailService, tokenManager) {
        var _this = this;
        this.route = route;
        this.globals = globals;
        this.router = router;
        this.detailService = detailService;
        this.tokenManager = tokenManager;
        this.router.events.subscribe(function (e) {
            _this.componentId = _this.route.snapshot.paramMap.get('id');
        });
    }
    LayoutDetailComponent.prototype.ngOnInit = function () {
        var self = this;
        this.tokenManager.store("BRNCurrentRoute", this.router.url);
        if (this.globals.Session == null) {
            self.router.navigate(['/', '/']);
        }
        ;
        this.componentId = this.route.snapshot.paramMap.get('id');
    };
    return LayoutDetailComponent;
}());
export { LayoutDetailComponent };
